import { useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { EditWholesaler } from "./EditWholesaler";

export const WholesalerTable = () => {
  const { wholesalersList } = useSelector((state) => state.catalogue);
  const [edit, setEdit] = useState(false)
  const [item, setItem] = useState({});

  const edit2 = (item) => {
    setEdit(true);
    setItem(item)
  }

  const columns = [
    {
      name: "Nombre",
      selector: row => [row.name],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.name}</span>
    },
    {
      name: "Codigo",
      selector: row => [row.code],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.code}</span>
    },
    {
      name: "Direccion",
      selector: row => [row.address],
      sortable: true,
      width: "200px",
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.address}</span>
    },
    {
      name: "Telefono",
      selector: row => [row.telephone],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.telephone}</span>
    },
    {
      name: "Correo Electronico",
      selector: row => [row.email],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.email}</span>
    },
    {
      name: "Estatus",
      selector: row => [row.status],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.status === 1 ? "Activo" : "Inactivo"}</span>
    },
    {
      name: "Editar",
      width: "85px",
      cell: row => <span className="text-center w-100">
        <i className={`fe fe-edit .hover`} role='button' onClick={() => edit2(row)}></i>
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: wholesalersList,
  };
  return (
    <>
      <DataTableExtensions {...tableDatas} >
        <DataTable
          columns={columns}
          data={wholesalersList}
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          striped={true}
          center={true}
          persistTableHead
          pagination
          highlightOnHover />
      </DataTableExtensions>
      <EditWholesaler item={item} isOpen={edit} setIsOpen={setEdit} />
    </>
  )
}